import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Select, Button, Form, Input, message, Row, Col } from "antd";

import { updateMyInfo } from "../dashboard/actions";
import {
  actionHideLoading,
  actionShowLoading,
  actionGetProfile,
} from "../../features/system/actions";
import { IconEditBlue } from "../../assets/index";
import { routes } from "../../utils/constants/constant";
import { isEmpty } from "../../utils/helpers/helpers";
import BreadCrumbComponent from "../../components/breadcrumb/BreadCrumbComponent";

import "./Account.scss";
import MobileBreadCrumb from "../../components/V2/Mobile/MobileBreadCrumb/MobileBreadCrumb";
import clsx from "clsx";

const breadCrumbs = [
  {
    name: "Trang chủ",
    isLink: true,
    link: routes.DASHBOARD,
  },
  {
    name: "Tài khoản của tôi",
    isLink: false,
  },
];
const { Option } = Select;

const Account = (props) => {
  const { mode } = props;

  const [form] = Form.useForm();
  const [isEdit, setIsEdit] = useState(true);

  useEffect(() => {
    const profile = props?.profile || {};
    const userInfo = !isEmpty(profile?.userInfo) ? profile?.userInfo : {};
    const bankAccount = !isEmpty(userInfo?.bankAccount)
      ? userInfo?.bankAccount
      : {};
    if (!isEmpty(userInfo)) {
      form.setFieldsValue({
        email: userInfo?.email || "",
        name: userInfo?.name || "",
        bankName: bankAccount?.bankName || "",
        accountNumber: bankAccount?.accountNumber || "",
        accountName: bankAccount?.accountName || "",
      });
    }
    // eslint-disable-next-line
  }, [props.profile]);

  const onFinishFailed = (errorInfo) => {};

  const onFinish = async (values) => {
    try {
      const dataDTO = {
        email: values?.email || "",
        name: values?.name || "",
        bankAccount: {
          bankName: values.bankName || "",
          accountName: values.accountName || "",
          accountNumber: values.accountNumber || "",
        },
      };
      props.actionShowLoading();
      const { data } = await updateMyInfo(dataDTO);
      props.actionHideLoading();
      if (data.code === 200) {
        props.actionGetProfile();
        setIsEdit(true);
        message.success(`Cập nhật thông tin tài khoản thành công!`);
      } else {
        message.error(
          data?.message || `Cập nhật thông tin tài khoản không thành công!`
        );
      }
    } catch (error) {
      props.actionHideLoading();
    }
  };
  return (
    <div className={clsx("container-account", mode)}>
      <MobileBreadCrumb hideBackButton={mode !== "mobile"} />

      <div className="title-container-account">
        <span>Tài khoản của tôi</span>
        {mode === "mobile" && (
          <Button
            type="text"
            className="btn-edit"
            icon={<IconEditBlue />}
            onClick={() => setIsEdit(!isEdit)}
          >
            {isEdit ? "Chỉnh sửa" : "Khóa sửa"}
          </Button>
        )}
      </div>
      <div className="info-user-box">
        <span className="text-info-user-box">Thông tin cá nhân</span>
        {mode !== "mobile" && (
          <Button
            type="text"
            className="btn-edit"
            icon={<IconEditBlue />}
            onClick={() => setIsEdit(!isEdit)}
          >
            {isEdit ? "Chỉnh sửa" : "Khóa sửa"}
          </Button>
        )}
      </div>
      <Form
        form={form}
        hideRequiredMark
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        className="account-form"
        layout="vertical"
      >
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label="Họ tên"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập Họ tên",
                },
                {
                  max: 50,
                  message: "Họ tên không vượt được quá 50 ký tự",
                },
              ]}
            >
              <Input
                disabled={isEdit}
                placeholder="Nhập Họ tên"
                className="input-banner-form"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập Email",
                },
              ]}
            >
              <Input
                disabled={isEdit}
                placeholder="Nhập Email"
                className="input-banner-form"
              />
            </Form.Item>
          </Col>
          <Col span={8}></Col>
        </Row>
        <div className="info-bank-account">
          <span className="title-info-bank-account">Thông tin tài khoản</span>
          <span>
            Hoa hồng sẽ được tổng kết vào ngày 15 hằng tháng khi hoa hồng của
            bạn đạt mức tối thiểu để nhận thanh toán.
          </span>
        </div>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              // label="Ngân hàng"
              name="bankName"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập Ngân hàng",
                },
              ]}
            >
              {!isEmpty(props?.listBank) && (
                <Select disabled={isEdit} className="select-banner-form">
                  <Option value="" disabled selected hidden>
                    <div className="option-text placehoder">Ngân Hàng</div>
                  </Option>
                  {props?.listBank?.map((el) => (
                    <Option value={el.name} key={el.name}>
                      <div className="option-text">{`${el.name} (${el.description})`}</div>
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              // label="Tên tài khoản"
              name="accountName"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập Tên tài khoản",
                },
                {
                  max: 50,
                  message: "Tên tài khoản không được vượt quá 50 ký tự",
                },
              ]}
            >
              <Input
                disabled={isEdit}
                placeholder="Tên tài khoản"
                className="input-banner-form"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              // label="Số tài khoản"
              name="accountNumber"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập Số tài khoản",
                },
              ]}
            >
              <Input
                disabled={isEdit}
                placeholder="Số tài khoản"
                className="input-banner-form"
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item style={{ marginBottom: "16px" }}>
          <Button
            type="primary"
            htmlType="submit"
            className={clsx("submit-save", { disabled: isEdit })}
          >
            Lưu
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default connect(
  (state) => ({
    profile: state.systemReducer.profile,
    generalInfo: state.systemReducer.generalInfo,
    listBank: state.systemReducer.listBank,
  }),
  { actionHideLoading, actionShowLoading, actionGetProfile }
)(withRouter(Account));
